const DURATION_READ_TIMEOUT_MS = 10000

export const getAudioFileDuration = (file: File): Promise<number> =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const audio = new Audio(url)

    const cleanup = () => URL.revokeObjectURL(url)

    const timer = setTimeout(() => {
      cleanup()
      reject(new Error('Timed out reading audio duration'))
    }, DURATION_READ_TIMEOUT_MS)

    audio.addEventListener('loadedmetadata', () => {
      clearTimeout(timer)
      cleanup()
      if (!Number.isFinite(audio.duration)) {
        reject(new Error('Failed to read audio duration'))
        return
      }
      resolve(audio.duration)
    })

    audio.addEventListener('error', () => {
      clearTimeout(timer)
      cleanup()
      reject(new Error('Failed to read audio duration'))
    })
  })
